module.exports = __webpack_public_path__ + "img/phone-round-icon.b297829d.svg";